export default __webpack_public_path__ + "static/media/cam.9676bdbe.svg";